<template>
  <div style="background: #fff;">
    <div style="font-size:24px;color:#000;font-weight:bold;margin:40px 0 0 35px;">Saved Lists</div>
    <div style="font-size:16px;color:#000;margin:20px 0 40px 35px;">Save products you want to purchase or your favorite products and share with colleagues and friends</div>
    <div style="width:auto;padding:0 20px;">
      <!-- <div style="width:25%;height:200px;border-radius:10px;background:#f5f5f5;margin-right:20px;float:left;">
        <p style="font-size:18px;color:#000;padding:26px 0 23px 26px">Default Saved List</p>
        <button style="font-size:20px;color:#fff;font-weight:bold;margin-left:26px;padding:16px 30px;background:#00718c;border-radius:6px;">+ CREATE LIST</button>
      </div> -->
      <div style="">
        <!-- <div style="position:relative;width:400px;height:40px;margin-left:26%;background:#f5f5f5;border-radius:3px;">
          <img src="../../assets/support_search.png" style="width:28px;height:28px;position:absolute;left:25px;top:7px;z-index:2;">
          <el-input clearable v-model="keybords" @change="changeValue" placeholder="Add Product by Stock No." style="padding-left:58px;"></el-input>
        </div> -->
        <div style="box-shadow: 0 0 6px rgba(111, 107, 97, 0.19);padding:25px;margin:20px 0 50px;">
          <div style="display:flex;align-items:center;flex-direction: row;justify-content: space-between;border-bottom:1px solid #e1e1e1;padding:25px 10px 36px 10px;" v-for="(item, index) in savedQueryList" :key="index">
            <div style="display:flex;justify-content: center;align-items: center;">
              <!-- <div style="width:140px;height:140px;background:#000;">
                <a ><img style="width:141px;height:141px;" :src="item.productImage" /></a>
              </div> -->
              <div class="img-sty">
                  <a class="img-hover"><img class="img-wh" :src="item.productImage" /></a>
                </div>
              <div style="margin-left:44px;">
                <p style="font-size:20px;font-weight:bold;color:#343434;">{{ item.productName }} <button style="font-size:18px;padding:10px;color:#fff;background:#1c7700;border-radius:6px;margin-left:20px;">{{ item.productInventory }}</button></p>
                <!-- <p style="font-size:18px;color:#8d8d8d;margin-top:15px;">Product number:xxxxxxxxxxx</p>
                <p style="font-size:18px;color:#8d8d8d;margin-top:5px;">series number:xxxxxx</p> -->
                <p style="font-size:18px;color:#00718c;margin-top:15px;">
                  <!-- <a style="font-size:18px;color:#00718c">Request Quote</a>
                  <span style="margin:0 6px;">|</span>
                  <a style="font-size:18px;color:#00718c">Move To List</a>
                  <span style="margin:0 6px;">|</span> -->
                  <a @click="goRemove(item)" style="font-size:18px;color:#00718c">Remove</a>
                </p>
              </div>
            </div>
            <div style="display:flex;">
               <el-input style="width:36px;text-align:center;height:36px;background:#fff;" type="text" v-model="item.num" clearable placeholder=""></el-input>
               <a class="a1" @click="goMoveCart(item)" style="margin-left:50px;padding:14px 22px;color:#fff;background:#00718c;border-radius:6px;font-size:16px;">MOVE TO CART</a>
            </div>
          </div>
          <div style="margin:30px 0 65px 0;">
            <a @click="goDelete" style="font-size:18px;color:#00718c;">Delete List</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { 
      savedQueryList,
      savedRemove,
      savedMoveToCart,
      savedDeleteList,
     } from '@/api/Persona/index' ;
    export default {
        name: 'Savedlists',
        components: {},
        data () {
            return {
              // keybords:'',
              savedQueryList: [],
            }
        },
        methods: {
          getSavedQueryList() {
              const params = {};
              savedQueryList(params).then((res) => {
                console.log(res, 'savedQueryList');
                this.savedQueryList = res;
              });
          },
          goRemove(row) {
            savedRemove({productId: row.productId}).then((res) => {
              console.log(res, 'savedRemove');
              this.getSavedQueryList();
            });
          },
          goMoveCart(row) {
            savedMoveToCart({productId: row.productId}).then((res) => {
              console.log(res, 'savedMoveToCart');
              this.getSavedQueryList();
            });
          },
          goDelete() {
            savedDeleteList({}).then((res) => {
              console.log(res, 'savedDeleteList');
              this.getSavedQueryList();
            });
          },
          // changeValue(val) {
          //   this.keybords = val;
          // },
        },
        mounted() {
          this.getSavedQueryList();
        },
    }
</script>

<style scoped>
::v-deep .el-input__inner {
  /* border:none !important; */
  /* background:#f5f5f5; */
}
::v-deep .el-input__inner {
  padding:0;
  text-align:center;
}
.img-sty {
    width:143px;
    height:143px;
    overflow: hidden;
    max-width:141px;
    max-height:141px;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    width:100%;
    height:auto;
    max-height:141px;
    max-width:100%;
  }
</style>